<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <div class="form-col">
          <el-form-item>
            <el-button type="primary" v-show="authList.includes('taskList:add')" icon="el-icon-plus" @click="addTask">{{ $t('eIoT.taskList.add') }}</el-button>
          </el-form-item>
        </div>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="taskId" :label="$t('eIoT.transmit.taskId')"></el-table-column>
      <el-table-column prop="taskName" :label="$t('eIoT.taskList.typeName')">
        <template #default="{ row }">
          <el-space>
            <el-tag size="small" type="success">{{ typeMap[row.type] }}</el-tag>{{ row.taskName }}
          </el-space>
        </template>
      </el-table-column>
      <el-table-column prop="site" :label="$t('activity.list.location')"/>
      <el-table-column prop="collector" :label="$t('eIoT.taskList.collector')"/>
      <el-table-column prop="robotSN" :label="$t('eIoT.deviceConfig.robotCode')"/>
      <el-table-column prop="subTaskCount" :label="$t('eIoT.taskList.taskProgress')">
        <template #default="{ row }">
          {{ row.subTaskFinishCount || 0 }}/{{ row.subTaskCount }}
        </template>
      </el-table-column>
      <el-table-column prop="deadline" :label="$t('eIoT.taskList.deadline')"/>
      <el-table-column prop="priority" :label="$t('eIoT.taskList.priority')">
        <template #default="{ row }">
          <el-tag v-if="row.priority" size="small" :type="priorityTag[row.priority]">{{ priorityMap[row.priority] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('collect.tasklist.taskStatus')">
        <template #default="{ row }">{{ taskStatusMap[row.taskStatus] }}</template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')"/>
      <el-table-column :label="$t('activity.list.operation')" width="100" fixed="right">
        <template #default="{ row }">
          <el-tooltip class="item" effect="dark" :content="$t('points.exchange.view')">
            <el-button
              v-show="authList.includes('taskList:detail')"
              @click="viewTask(row)"
              type="text"
              size="default"
              icon="el-icon-view"
            />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('activity.list.edit')">
            <el-button
              v-show="authList.includes('taskList:edit') && row.taskStatus == 1"
              @click="editTask(row)"
              type="text"
              size="default"
              icon="el-icon-edit"
            />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.viewUploadedData')">
            <el-button
              v-show="authList.includes('taskList:viewUploadedData')"
              @click="viewUploaded(row)"
              type="text"
              size="default"
              icon="el-icon-coin"
            />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('collect.tasklist.earlyTermination')">
            <el-button
              v-show="authList.includes('taskList:earlyTermination') && row.taskStatus == 2"
              @click="terminateTask(row)"
              type="text"
              size="default"
              style="color: red;"
              icon="el-icon-circle-close"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="taskTitle" v-model="taskFormVisible" top="5vh" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="formRef" class="dialog-form" :model="form" :rules="formRules" :label-width="curLang == 'zh-CN' ? '150px' : curLang == 'en-US' ? '240px' : '220px'">
        <el-form-item :label="$t('eIoT.deviceConfig.type')" prop="type">
          <el-select v-model="form.type" :placeholder="$t('eIoT.deviceConfig.type')" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.site')" prop="site">
          <el-input v-model="form.site" :placeholder="$t('eIoT.taskList.site')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.scene')" prop="scene">
          <el-input v-model="form.scene" :placeholder="$t('eIoT.taskList.scene')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.station')" prop="station">
          <el-input v-model="form.station" :placeholder="$t('eIoT.taskList.station')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.unit')" prop="unit">
          <el-input v-model="form.unit" :placeholder="$t('eIoT.taskList.unit')"/>
        </el-form-item>
        <el-form-item :label="$t('collect.messagelist.taskName')" prop="taskName">
          <el-input v-model="form.taskName" :placeholder="$t('collect.messagelist.taskName')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.taskCategory')" prop="taskCategory">
          <el-select v-model="form.taskCategory" :placeholder="$t('eIoT.taskList.taskCategory')" clearable>
            <el-option
              v-for="item in taskCategoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.taskDesc')" prop="taskDescription">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="form.taskDescription" :placeholder="$t('eIoT.taskList.taskDesc')"/>
        </el-form-item>
        <!-- <el-form-item :label="$t('eIoT.taskList.assignRobot')" prop="robotSN">
          <el-select v-model="form.robotSN" :placeholder="$t('eIoT.taskList.assignRobot')" :remote-method="robotSnQuery" @change="(val)=>onRobotChange(val)" filterable remote clearable>
            <el-option
              v-for="(item) in robotSnList"
              :key="item.deviceCode"
              :label="item.deviceCode"
              :value="item.deviceCode"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('eIoT.taskList.endTool')" prop="endTool">
          <el-select v-model="form.endTool" :placeholder="$t('eIoT.taskList.endTool')" clearable>
            <el-option
              v-for="item in endToolList"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.assignCollector')" prop="collector">
          <el-select v-model="form.collectorId" :placeholder="$t('eIoT.taskList.assignCollector')" :remote-method="getUserListByName" @change="(val)=>onUserChange(val)" filterable remote clearable>
            <el-option
              v-for="(item) in userList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.taskCount')" prop="subTaskCount">
          <el-input v-model="form.subTaskCount" :placeholder="$t('eIoT.taskList.taskCountRange')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.deadline')">
          <el-date-picker
            v-model="form.deadline"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('eIoT.taskList.deadline')"
          />
        </el-form-item>
        <el-form-item :label="$t('eIoT.taskList.priority')" prop="priority">
          <el-radio-group v-model="form.priority" >
            <el-radio v-for="item  in priorityList" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmitTask">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="$t('eIoT.taskList.viewTask')" v-model="taskDetailVisible" top="5vh" destroy-on-close :modal="true" :append-to-body="true">
      <el-descriptions class="dialog-desc" :column="1" style="margin: 0 20px;">
        <el-descriptions-item :label="$t('eIoT.transmit.taskId')">{{ detail.taskId }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.deviceConfig.type')">{{ typeMap[detail.type] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.site')">{{ detail.site }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.scene')">{{ detail.scene }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.station')">{{ detail.station }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.unit')">{{ detail.unit }}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.messagelist.taskName')">{{ detail.taskName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.taskCategory')">{{ taskCategoryMap[detail.taskCategory] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.taskDesc')">{{ detail.taskDescription }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.skill')">{{ detail.skills?.map(s => skillMap[s]).join(', ') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.steps')">{{ detail.strategies?.map(s => skillMap[s]).join(' -> ') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.deviceConfig.robotCode')">{{ detail.robotSN }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.endTool')">{{ endToolMap[detail.endTool] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.assignCollector')">{{ detail.collector }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.taskCount')">{{ detail.subTaskCount }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.deadline')">{{ detail.deadline }}</el-descriptions-item>
        <el-descriptions-item :label="$t('eIoT.taskList.priority')">{{ priorityMap[detail.priority] }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request';
import { common } from '@/common/mixin';
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessageBox, ElMessage } from 'element-plus'
import { ref, reactive, toRefs, computed, onMounted } from "vue";
import { useRouter } from 'vue-router'
import { useStore } from "vuex";
import { reqFileList, reqBindRobotList } from '@/api/resource';
import { useI18n } from 'vue-i18n'
import { intValidator } from '../../common/utils'
import { arrayToMap, maskPhone } from '@/utils/index'

export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  setup() {
    const router = useRouter()
    const store = useStore()
    const { t } = useI18n()
        const typeList = [
      { label: 'VLA', value: 1 },
      { label: 'VLM', value: 2 },
      { label: 'RL', value: 3 },
      { label: 'AGENT', value: 4 },
    ]
    const typeMap = arrayToMap(typeList, 'value', 'label')
    const taskStatusList = [
      { label: t('eIoT.taskList.taskStatusList[0]'), value: 1 },
      { label: t('eIoT.taskList.taskStatusList[1]'), value: 2 },
      { label: t('eIoT.taskList.taskStatusList[2]'), value: 3 },
      { label: t('eIoT.taskList.taskStatusList[3]'), value: 4 },
      { label: t('eIoT.taskList.taskStatusList[4]'), value: 7 },
    ]
    const taskStatusMap = arrayToMap(taskStatusList, 'value', 'label')

    const taskCategoryList = [
      { label: 'assembly', value: 1 },
      { label: 'grasping', value: 2 },
      { label: 'insertion', value: 3 },
      { label: 'routing', value: 4 },
      { label: 'inspection', value: 5 },
      { label: 'sorting', value: 6 },
      { label: 'manipulation', value: 7 },
    ]
    const taskCategoryMap = arrayToMap(taskCategoryList, 'value', 'label')
    const priorityList = [
      { label: t('eIoT.taskList.priorityList[0]'), value: '1', tag: 'danger' },
      { label: t('eIoT.taskList.priorityList[1]'), value: '2', tag: 'warning' },
      { label: t('eIoT.taskList.priorityList[2]'), value: '3', tag: 'warning' },
      { label: t('eIoT.taskList.priorityList[3]'), value: '4', tag: 'success' },
    ]
    const priorityMap = arrayToMap(priorityList, 'value', 'label')
    const priorityTag = arrayToMap(priorityList, 'value', 'tag')
    const endToolList = ref([])
    const endToolMap = ref({})
    const skillList = ref([])
    const skillMap = ref({})
    const state = reactive({
      taskFormVisible: false,
      taskDetailVisible: false,
      formRef: null,
      form: {
        id: '',
        taskId: '',
        type: '', // 类型 1:VLA,2:VLM,3:RL,4:AGENT
        site: '', // 场地
        scene: '', // 场景
        station: '', // 工位
        unit: '', // 单元
        taskName: '', // 任务名称
        taskCategory: '', // 任务大类
        taskDescription: '', // 任务描述
        robotSN: '', // 指派机器人
        endTool: '', // 末端工具 1:夹爪,2:吸盘,3:灵巧手
        collector: '', // 指派采集员
        collectorId: '',
        subTaskCount: '', // 目标采集数量 1~100
        deadline: '', // 截止时间
        priority: '', // 优先级 1:紧急，2:高，3:普通，4:低
      },
      formRules: {
        type: {
          required: true,
          message: t('status.largescreenm.pleaseSelect'),
          trigger: 'blur',
        },
        site: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur',
        },
        scene: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur'
        },
        taskName: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur'
        },
        taskCategory: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur'
        },
        // robotSN: {
        //   required: true,
        //   message: t('status.largescreenm.pleaseEnter'),
        //   trigger: 'blur'
        // },
        endTool: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur'
        },
        collector: {
          required: true,
          message: t('status.largescreenm.pleaseEnter'),
          trigger: 'blur'
        },
        subTaskCount: intValidator({
          label: t('eIoT.taskList.taskCount'),
          min: 0,
          max: 100
        })
      },
      params: [
        {
          key: 'robotSN',
          value: '',
          label: t('eIoT.deviceConfig.robotCode')
        },
        {
          key: 'collector',
          value: '',
          label: t('eIoT.taskList.collector')
        },
        {
          type: "Select",
          key: "taskStatus",
          value: '',
          label: t('collect.tasklist.taskStatus'),
          options: {
            data: taskStatusList,
            label: 'label',
            value: 'value'
          }
        },
        {
          type: "Date",
          key: "createTimeRange",
          value: [],
          label: t('activity.list.createTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList')),
      detail: {},
      robotSnList: [],
      userList: [],
      taskTitle: t('eIoT.taskList.addTask'),
      fileList: [],
      robotList: []
    })
    const getData = async () => {
      try {
        const res = await request('getEmbodyTaskList', {
          ...state.query,
          page: state.page,
          size: state.size,
        })
        state.tableDataList = res.records || []
        state.total = Number(res.total || 0)
      } catch (error) {
        console.error(error)
      }
    }

    const searchData = (data) => {
      state.query = data
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1;
      state.size = size || 10;
      getData()
    }
    const getSkills = async () => {
      try {
        const res = await request('getDictData', {
          dictType: 'embodySkill'
        })
        skillList.value = res || []
        skillMap.value = arrayToMap(skillList.value, 'dictCode', 'dictLabel')
      } catch (error) {
        console.error(error)
      }
    }
    const getEndtools = async () => {
      try {
        const res = await request('getDictData', {
          dictType: 'endTool'
        })
        endToolList.value = res || []
        endToolMap.value = arrayToMap(endToolList.value, 'dictCode', 'dictLabel')
      } catch (error) {
        console.error(error)
      }
    }
    const addTask = () => {
      state.taskTitle = t('eIoT.taskList.addTask')
      for (let key of Object.keys(state.form)) {
        state.form[key] = ''
      }
      state.taskFormVisible = true
    }
    const editTask = (data) => {
      state.taskTitle = t('eIoT.taskList.editTask')
      for (let key of Object.keys(state.form)) {
        if (data[key]) {
          state.form[key] = data[key]
        } else {
          state.form[key] = ''
        }
      }
      if (data.collectorId) {
        state.userList = [
          {
            label: data.collector,
            value: data.collectorId
          }
        ]
      }
      if (data.endTool) state.form.endTool = String(data.endTool)
      state.form.id = data.id
      state.taskFormVisible = true
      return
    }
    const viewTask = async (row) => {
      try {
        state.detail = row
        state.taskDetailVisible = true
      } catch (error) {
        console.error(error)
      }
    }
    const terminateTask = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('eIoT.taskList.confirmTerminate'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        await request('terminateEmbodyTask', {
          taskId: row.taskId,
        })
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const viewUploaded = (row) => {
      router.push(`/eIoT/transmitted?taskId=${row.taskId}`)
    }
    const robotSnQuery = async (name) => {
      try {
        state.robotSnList = []
        const res = await request('deviceList', {
          deviceType: 1,
          deviceCode: name,
          page: 1,
          size: 20
        })
        state.robotSnList = res.records || []
      } catch (error) {
        console.error(error)
      }
    }
    const getUserListByName = async (userName) => {
      try {
        const res = await request("getUserList", { userName, roleName: '采集员' })
        state.userList = (res.records || []).slice(0, 20)
        state.userList.forEach(item=> {
          item.label = `${item.userName}(${maskPhone(item.phoneNumber)})`
          item.value = item.id
        })
      } catch (error) {
        console.error(error)
      }
    }
    const onRobotChange = (val) => {
      const currtRobot = state.robotSnList.filter(item=> item.deviceCode == val)[0]
      state.form.robotName = currtRobot?.deviceName
    }
    const onUserChange = (val) => {
      const currtUser = state.userList.filter(item=> item.value == val)?.[0]
      state.form.collector = currtUser?.label
    }
    const onSubmitTask = async () => {
      try {
        await state.formRef?.validate()
        const url = state.form.id ? 'updateEmbodyTask' : 'createEmbodyTask'
        await request(url, state.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
        state.taskFormVisible = false
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    onMounted(() => {
      getData()
      getSkills()
      getEndtools()
    })
    return {
      ...toRefs(state),
      typeList,
      typeMap,
      taskStatusList,
      taskStatusMap,
      taskCategoryList,
      taskCategoryMap,
      priorityList,
      priorityMap,
      priorityTag,
      endToolList,
      endToolMap,
      skillMap,
      maskPhone,
      getData,
      searchData,
      updatePage,
      addTask,
      editTask,
      viewTask,
      viewUploaded,
      robotSnQuery,
      getUserListByName,
      onRobotChange,
      onUserChange,
      onSubmitTask,
      terminateTask
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.dialog-desc :deep(.el-descriptions__label) {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.dialog-desc :deep(.el-descriptions__label::after) {
  content: ":";
  position: relative;
  margin-left: 2px;
}
</style>
